import { Location } from 'vue-router'
import { CollectorPublication as Data, Session } from '@/typings/api/CollectorPublication'
import { BASE_TABLE_HEADERS } from '@/views/CollectorPublications/table-headers'
import {
  createEdit, createView,
} from '@/helpers/enums/table-actions'
import { OKU_COLLECTOR_PUBLICATIONS_ROUTES as ROUTES } from './utils'


const getEditRoute = (data: Data): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.publication_id.toString() },
})

const getViewRoute = (data: Data): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.publication_id.toString() },
})

export const getSessionNames = (data: Data, sessions: Session[]) => {
  if (sessions?.length > 0 && data.session_digit_code) {
    return sessions.filter(({ digit_code }) => digit_code === data.session_digit_code).map(({ name }) => name).join(', ')
  }

  return ''
}

export const TABLE_ACTIONS_ADMIN = Object.freeze([
  createView<Data>(getViewRoute),
])

export const TABLE_ACTIONS = Object.freeze([
  createEdit<Data>(getEditRoute),
])


export const TABLE_HEADERS = Object.freeze([
  ...BASE_TABLE_HEADERS,
])
